import { useLanguage } from "../i18n/LanguageContext";
import { Reveal, SectionLabel } from "./Reveal";
import { languages } from "../i18n/translations";

export const Contact = () => {
  const { t, lang, setLang } = useLanguage();

  return (
    <section id="contact" data-testid="contact-section" className="pt-24 md:pt-60">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid grid-cols-12 pb-32 md:pb-48">
          <div className="col-span-12 md:col-span-8 md:col-start-2">
            <Reveal>
              <SectionLabel>{t.contact.label}</SectionLabel>
            </Reveal>
            <Reveal delay={0.1}>
              <h2
                data-testid="contact-heading"
                className="mt-10 font-normal text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.1]"
              >
                {t.contact.heading}
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-10 md:mt-12 max-w-xl text-base md:text-lg leading-relaxed text-foreground/70 tracking-wide">
                {t.contact.body}
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <a
                data-testid="contact-email-link"
                href={`mailto:${t.contact.email}`}
                className="mt-14 md:mt-16 inline-block font-normal text-2xl md:text-3xl lg:text-4xl tracking-tight border-b border-foreground/30 hover:border-foreground transition-colors duration-500"
              >
                {t.contact.emailLinkText}
              </a>
            </Reveal>
          </div>
        </div>
      </div>

      <footer data-testid="site-footer" className="border-t border-foreground/10">
        <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-14 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <p className="text-sm font-light uppercase tracking-[0.25em]">Camila Valentoni</p>
          <p className="text-xs uppercase tracking-[0.25em] text-foreground/50">{t.contact.footerLine}</p>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-1">
              {languages.map((l) => (
                <button
                  key={l.code}
                  data-testid={`footer-lang-${l.code}-button`}
                  onClick={() => setLang(l.code)}
                  className={`px-1.5 text-xs tracking-[0.15em] transition-colors duration-300 ${
                    lang === l.code ? "text-foreground" : "text-foreground/40 hover:text-foreground/80"
                  }`}
                >
                  {l.label}
                </button>
              ))}
            </div>
            <p className="text-xs text-foreground/40">© {new Date().getFullYear()}. {t.contact.rights}</p>
          </div>
        </div>
      </footer>
    </section>
  );
};
